/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Brand-icon-office-color': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<g clip-path="url(#clip0)"><path pid="0" d="M2 19.379l12.82 1.69V4.173L6.522 6.112V17.44L2 19.379V4.969L14.77 0l7.106 2.385v19.28L14.77 24 2 19.379z" _fill="#E73F24"/></g><defs><clipPath id="clip0"><path pid="1" d="M0 0h24v24H0V0z" _fill="#fff"/></clipPath></defs>'
  }
})
